import { createMMBHandlers } from './handlers';
export const mmbHandlers = createMMBHandlers(window.Odigeo);